export default {
      id: "sentiment-client-neutral-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#sentiment-client-neutral-usage",
      toString: function () {
        return this.url;
      }
    }